import { defineComponent as c, openBlock as a, createBlock as l, withCtx as t, createVNode as o, unref as n, createCommentVNode as i } from "vue";
import f from "../../../icons/generated/IconCross.vue2.js";
import b from "../../../icons/generated/IconDownload.vue2.js";
import m from "./DocumentSmallAvatar.vue2.js";
import s from "./DocumentSmallBase.vue2.js";
import { RevIllustration as B } from "@ds/components/Illustration";
const D = /* @__PURE__ */ c({
  name: "DocumentDefaultSmall",
  __name: "DocumentDefaultSmall",
  props: {
    name: {},
    url: {},
    deletable: { type: Boolean },
    thumbnail: { type: Boolean },
    downloadButtonAriaLabel: {},
    deleteButtonAriaLabel: {}
  },
  emits: ["delete"],
  setup(e, { emit: u }) {
    const d = u;
    return (k, r) => (a(), l(s, {
      "button-attrs": {
        target: "_blank",
        to: e.url
      }
    }, {
      avatar: t(() => [
        e.url && !e.deletable ? (a(), l(m, {
          key: 0,
          "aria-label": e.downloadButtonAriaLabel,
          download: e.name,
          to: e.url
        }, {
          default: t(() => [
            o(n(b), { size: "16" })
          ]),
          _: 1
        }, 8, ["aria-label", "download", "to"])) : i("", !0),
        e.deletable ? (a(), l(m, {
          key: 1,
          "aria-label": e.deleteButtonAriaLabel,
          onClick: r[0] || (r[0] = (w) => d("delete"))
        }, {
          default: t(() => [
            o(n(f), { size: "16" })
          ]),
          _: 1
        }, 8, ["aria-label"])) : i("", !0)
      ]),
      default: t(() => [
        o(n(B), {
          alt: "",
          height: 64,
          "image-class-names": "size-64 object-cover object-center",
          src: e.url,
          title: e.name,
          width: 64
        }, null, 8, ["src", "title"])
      ]),
      _: 1
    }, 8, ["button-attrs"]));
  }
});
export {
  D as default
};
